import { CameraPosition, IrLightPosition } from '@/api/controlUnitApi/types.gen'
import { Rectangle } from './types'

const CAMERA_POSITIONS: CameraPosition[] = ['FL', 'FC', 'FR', 'RL', 'RR']

const FRONT_CAMERA_POSITIONS: CameraPosition[] = ['FL', 'FC', 'FR']

const IR_LIGHT_POSITIONS: IrLightPosition[] = ['FL', 'FR']

const CAMERA_KEYS = {
  FL: { name: 'frontLeft', label: 'frontLeftLabel', zoom: 'frontLeftZoom', aperture: 'frontLeftAperture' },
  FC: { name: 'frontCenter', label: 'frontCenterLabel', zoom: 'frontCenterZoom', aperture: 'frontCenterAperture' },
  FR: { name: 'frontRight', label: 'frontRightLabel', zoom: 'frontRightZoom', aperture: 'frontRightAperture' },
  RL: { name: 'rearLeft', label: 'rearLeftLabel', zoom: 'rearLeftZoom', aperture: 'rearLeftAperture' },
  RR: { name: 'rearRight', label: 'rearRightLabel', zoom: 'rearRightZoom', aperture: 'rearRightAperture' },
} as const satisfies Record<CameraPosition, { name: string; label: string; zoom: string; aperture: string }>

const IR_LIGHT_KEYS = {
  FL: { name: 'frontLeft', infrared: 'frontLeftInfrared' },
  FR: { name: 'frontRight', infrared: 'frontRightInfrared' },
} as const satisfies Record<IrLightPosition, { name: string; infrared: string }>

const translateToNaturalScale = (displayedRectangle: Rectangle, imageElement: HTMLImageElement): Rectangle => {
  const scaleX = imageElement.naturalWidth / imageElement.offsetWidth
  const scaleY = imageElement.naturalHeight / imageElement.offsetHeight

  return {
    ...displayedRectangle,
    x: Math.round(displayedRectangle.x * scaleX),
    y: Math.round(displayedRectangle.y * scaleY),
    width: Math.round(displayedRectangle.width * scaleX),
    height: Math.round(displayedRectangle.height * scaleY),
  }
}

export {
  CAMERA_KEYS,
  CAMERA_POSITIONS,
  FRONT_CAMERA_POSITIONS,
  IR_LIGHT_KEYS,
  IR_LIGHT_POSITIONS,
  translateToNaturalScale,
}
